import React, { memo, forwardRef } from "react";
const SvgMatrix31 = forwardRef((props, svgRef) => {
  return (
    <svg
      width={32}
      height={32}
      fill="none"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <rect width={6} height={6} x={13} y={5} fill="#DBDBDB" rx={1} />
      <rect width={6} height={6} x={13} y={13} fill="#DBDBDB" rx={1} />
      <rect width={6} height={6} x={13} y={21} fill="#DBDBDB" rx={1} />
      <path
        fill="#717171"
        d="M8.29 29H5.923C5.308 29 5 28.678 5 28.034V3.966C5 3.322 5.308 3 5.923 3H8.29c.473 0 .71.223.71.669 0 .446-.237.669-.71.669H6.562v23.324H8.29c.473 0 .71.223.71.67 0 .445-.237.668-.71.668zM23.71 29h2.367c.615 0 .923-.322.923-.966V3.966c0-.644-.308-.966-.923-.966H23.71c-.473 0-.71.223-.71.669 0 .446.237.669.71.669h1.728v23.324H23.71c-.473 0-.71.223-.71.67 0 .445.237.668.71.668z"
      />
    </svg>
  );
});
SvgMatrix31.displayName = "SvgMatrix31";
const MemoForwardRef = memo(SvgMatrix31);
export default MemoForwardRef;
